import { omit } from "lodash";

export const buildOptions = (options) => {
  return options.map((option) => {
    if (Array.isArray(option)) {
      return { value: option[0], label: option[1] };
    }
    return { value: option, label: option };
  });
};

export const buildResident = (props) => {
  let resident = {};

  if ("resident" in props) {
    resident = omit(props.resident, [
      "created_at",
      "updated_at",
      "deleted_at",
      "diagnosis",
      "id",
      "kipu_casefile_id",
      "location_status",
      "organization_id",
      "profile_picture_content_type",
      "profile_picture_file_name",
      "profile_picture_file_size",
      "profile_picture_updated_at",
      "profile_picture_url",
      "sign_up_code",
      "sign_up_created_at",
      "external_stripe_customer_id",
      "substance_of_choice",
    ]);
  }

  if ("medications" in props) {
    resident["medications_attributes"] = props.medications.map((medication) => {
      return omit(medication, [
        "resident_id",
        "deleted_at",
        "created_at",
        "updated_at",
      ]);
    });
  }

  if ("treatmentCenters" in props) {
    resident["treatment_centers_attributes"] = props.treatmentCenters.map(
      (treatment_center) => {
        return omit(treatment_center, [
          "resident_id",
          "deleted_at",
          "created_at",
          "updated_at",
        ]);
      }
    );
  }

  if ("childWelfareHistories" in props) {
    resident["child_welfare_histories_attributes"] = props.childWelfareHistories.map(
      (child_welfare_history) => {
        return omit(child_welfare_history, [
          "resident_id",
          "deleted_at",
          "created_at",
          "updated_at",
        ]);
      }
    );
  }

  if ("past_occupancies" in props) {
    resident["occupancies_attributes"] = props.occupancies.map((occupancy) => {
      return omit(occupancy, [
        "resident_id",
        "deleted_at",
        "created_at",
        "updated_at",
      ]);
    });
  }

  if ("occupancies" in props) {
    resident["occupancies_attributes"] = props.occupancies.map((occupancy) => {
      return omit(occupancy, [
        "resident_id",
        "deleted_at",
        "created_at",
        "updated_at",
      ]);
    });
  }

  if ("soberLivings" in props) {
    resident["sober_livings_attributes"] = props.soberLivings.map(
      (sober_living) => {
        return omit(sober_living, [
          "resident_id",
          "deleted_at",
          "created_at",
          "updated_at",
        ]);
      }
    );
  }

  if ("livingArrangementHistories" in props) {
    resident["living_arrangement_histories_attributes"] = props.livingArrangementHistories.map(
      (living_arrangement) => {
        return omit(living_arrangement, [
          "resident_id",
          "deleted_at",
          "created_at",
          "updated_at",
        ]);
      }
    );
  }

  if ("sobrieties" in props) {
    resident["sobrieties_attributes"] = props.sobrieties.map((sobriety) => {
      return omit(sobriety, [
        "resident_id",
        "deleted_at",
        "created_at",
        "updated_at",
      ]);
    });
  }

  if ("therapists" in props) {
    resident["therapists_attributes"] = props.therapists.map((therapist) => {
      return omit(therapist, [
        "resident_id",
        "deleted_at",
        "created_at",
        "updated_at",
      ]);
    });
  }

  // contacts
  // documents

  return resident;
};

export const sponsorOptions = buildOptions([
  [true, "Yes"],
  [false, "No"],
]);

export const getCurrentTimeWithCurrentTimezone = () => {
  const tz_offset = new Date().getTimezoneOffset() * 60000; //offset in milliseconds
  const nowWithTimezone = new Date(Date.now() - tz_offset)
    .toISOString()
    .slice(0, -1);
  return nowWithTimezone;
};

export const postDischargeDestinationOptions = buildOptions([
  "Sober Living",
  "Treatment Center",
  "Home",
  "Prison/Jail",
  "Other",
]);
